import React from "react";
import { useNavigate } from "react-router-dom";
import RoleSelector from "./RoleSelector";
import LanguageSelector from "./LanguageSelector";
import LogoutButton from "./LogoutButton";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleLogoClick = () => {
    document.documentElement.style.setProperty(
      "--assistant-border-color",
      "black"
    );
    const resetEvent = new CustomEvent('resetAssistantProperties');
    document.dispatchEvent(resetEvent);
    
    navigate("/");
  };

  return (
    <div className="mb-5">
      <div className="flex flex-row mx-4 justify-between h-18">
        <div className="cursor-pointer">
          <img
            src={process.env.REACT_APP_LOGO_URL || "/cs.png"}
            alt="logo"
            className="h-12 mt-4"
            onClick={handleLogoClick}
          />
        </div>

        <div className="mr-4 mt-4 flex items-center">
          <LanguageSelector />
          <RoleSelector />
          {isAuthenticated() && <LogoutButton />}
        </div>
      </div>
      <hr className="border-gray-50" />
    </div>
  );
};

export default Header;
